export const PAYOUT_PROGRESS_TITLE_MAP = {
  IntermediateDelivery: 'Intermediate delivery',
  AtIntermediateService: 'At intermediate service',
  MerchantDelivery: 'Merchant Delivery',
  Delivered: 'Delivered',
  Canceled: 'Canceled',
};

export const PAYOUT_PROGRESS_DESCRIPTION_MAP = {
  IntermediateDelivery: 'Delivery to intermediate service in progress'
    + ' (currently only Nium serves as "Intermediate service"',
  AtIntermediateService: 'Funds delivered to intermediate service but still not used',
  MerchantDelivery: 'Funds sent from intermediate service but not yet delivered to Merchant',
  Delivered: 'Funds delivered to Merchant',
  Canceled: 'Currently there is no way to set this status.'
    + ' The Payout cannot be completed.',
};

export const PAYOUT_STATUS_CLASS_MAP = {
  manual: 'm',
  automatic: 'a',
  error: 'e',
};

export const TRANSACTION_STATUS_TITLE_MAP = {
  IN_PROCESS: 'In process',
  AWAITING_FUNDS: 'Awaiting funds',
  COMPILANCE_VERIFICATION: 'Compliance verification',
  COMPILANCE_REJECTED: 'Compliance rejected',
  COMPILANCE_APPROVED: 'Compliance approved',
  INFO_REQUESTED: 'Info requested',
  PG_PROCESSING: 'PG processing',
  PAID: 'Paid',
  RETURNED: 'Returned',
  CANCELED: 'Canceled',
  ERROR: 'Error',
  USER_REJECTED: 'User rejected',
};

export const TRANSACTION_STATUS_DESCRIPTION_MAP = {
  IN_PROCESS: 'Payment in internal process on `Nium` side',
  AWAITING_FUNDS: 'Transaction is created but account doesn\'t have enough funds. '
    + 'Transaction will be resumed ones there is enough funds.',
  COMPILANCE_VERIFICATION: 'Payment compliance verification in progress.',
  COMPILANCE_REJECTED: 'Payment rejected by compliance.',
  COMPILANCE_APPROVED: 'Payment approved by compliance.',
  INFO_REQUESTED: 'Additional Remitter / Beneficiary information requested for compliance verification',
  PG_PROCESSING: 'Payment sent to beneficiary bank.',
  PAID: 'Payment successfully paid.',
  RETURNED: 'Payment returned from the beneficiary\'s bank.',
  CANCELED: 'Payment manually canceled.',
  ERROR: 'Payment instruction erroneous, appended by exact error response from beneficiary bank.',
  USER_REJECTED: 'The transaction was cancelled by the client.',
};
